/**
 * LaunchDarkly Configuration
 *
 * Uses the LaunchDarkly client-side ID from runtime window config (ECS) or Vite env (local).
 */

import { getRuntimeConfig } from "./runtime-config";

export interface LaunchDarklyConfig {
	clientSideId: string;
	enabled: boolean;
}

/**
 * Get LaunchDarkly configuration
 */
export const getLaunchDarklyConfig = (): LaunchDarklyConfig => {
	const rc = getRuntimeConfig();
	const enabled = rc.launchDarklyEnabled !== false;

	if (!enabled) {
		console.log("LaunchDarkly is disabled via launchDarklyEnabled / EFM_PUBLIC_LAUNCHDARKLY_ENABLED");
		return {
			clientSideId: "",
			enabled: false,
		};
	}

	const clientSideId = rc.launchDarklyClientId || "";

	if (!clientSideId) {
		console.error(
			`LaunchDarkly: No client-side ID configured. ` +
				`Set EFM_PUBLIC_LAUNCHDARKLY_CLIENT_ID (deployed) or VITE_LAUNCHDARKLY_CLIENT_ID in .env (local).`
		);
		return {
			clientSideId: "",
			enabled: false,
		};
	}

	console.log(`LaunchDarkly: Initialized with provided client-side ID`);

	return {
		clientSideId,
		enabled: true,
	};
};

/**
 * Feature Flag Keys
 * Define your feature flag keys here for type safety and easy reference
 */
export const FeatureFlags = {
	// Example feature flags - replace with your actual flags
	SHOW_TEMPLATES: "jhft_show_templates",
	SHOW_BUSINESS_UNITS: "jhft_show_business_unit",
	SHOW_IP_ALLOW_LIST: "jhft_show_ip_allow_list",
	/** SFTP/FTPS workflow: offer SSH private-key auth (vs password only). */
	SHOW_SFTP_SSH_OPTION: "jhft_show_sftp_ssh_option",
	/** OpCon / UI on-demand PULL workflow activation (FR-C11 kill switch). */
	OPCON_WORKFLOW_ACTIVATION: "jhft_opcon_workflow_activation",
	/** Institution management UI rollout under Business Unit Management. */
	INITIAL_INSTITUTION: "jhft_initial_institution",
	/** JHA Network SFTP / file share workflow storage types (ACME-1998 / jConnect). */
	JCONNECT_FEATURES: "jhft_jconnect_features",
} as const;

// Type for feature flag keys
export type FeatureFlagKey = (typeof FeatureFlags)[keyof typeof FeatureFlags];
